module.exports = __webpack_public_path__ + "img/fileIconRed.7535231f.png";